export const MEASURE_UNIT_BOX = 5;

export const LOCKED_FLAG_OPTIONS = [
  { label: '未结算', value: 0 },
  { label: '已生成结算单', value: 1 },
];

export const RECORD_STATUS = {
  VOIDED: 0,
  NORMAL: 1,
};

export const RECORD_STATUS_OPTIONS = [
  { label: '有效', value: RECORD_STATUS.NORMAL },
  { label: '已作废', value: RECORD_STATUS.VOIDED },
];

export const OPERATION_TYPE_MAP = {
  CREATE: '新增',
  ADD: '新增',
  UPDATE: '编辑',
  EDIT: '编辑',
  VOID: '作废',
  DELETE: '删除',
  LOCK: '结算锁定',
  EXPORT: '导出',
};

export const FRONT_LIFT_PERMISSION = {
  view: 'front_lift_execution_view',
  add: 'front_lift_execution_add',
  edit: 'front_lift_execution_edit',
  void: 'front_lift_execution_void',
  export: 'front_lift_execution_export',
  log: 'front_lift_execution_log',
};

export function operationTypeLabel(type) {
  return OPERATION_TYPE_MAP[type] || type || '-';
}

export function measureUnitLabel(unit) {
  return Number(unit) === MEASURE_UNIT_BOX ? '箱数' : unit || '-';
}

export function isVoidedStatus(status) {
  return Number(status) === RECORD_STATUS.VOIDED;
}

export function isLockedRecord(row = {}) {
  return row.lockedFlag === true ||
    Number(row.lockedFlag) === 1 ||
    !!row.lockedBillId ||
    row.settlementStatus === 'LOCKED' ||
    row.settlementStatus === 'GENERATED';
}

export function settlementStatusLabel(row = {}) {
  if (isVoidedStatus(row.status)) {
    return '已作废';
  }
  return isLockedRecord(row) ? '已生成结算单' : '未结算';
}
